module.exports = __webpack_public_path__ + "img/ps5.7b6ca4b2.png";